export default __webpack_public_path__ + "static/media/867.1bf14ca9.gif";